const { interpolateUrl } = require('./url');
const { get } = require('lodash');

const KB_BASE_URL = 'https://support.spotme.com/hc/en-us';
const KB_ARTICLE_BASE_URL = `${KB_BASE_URL}/articles`;
const KB_SECTION_BASE_URL = `${KB_BASE_URL}/sections`;
const SHORT_LINK_BASE_URL = 'https://sl.spotme.com';

const LINKS = {
    captions_ai_media: `${SHORT_LINK_BASE_URL}/howto-captioning`,
    cms_template: `${SHORT_LINK_BASE_URL}/cms-template`,
    download_app: `${SHORT_LINK_BASE_URL}/download-app`,
    free_email_domains_list: `${SHORT_LINK_BASE_URL}/blocked-email-domains`,
    getting_started: `${SHORT_LINK_BASE_URL}/getting-started`,
    speaker_feedback_form: `${SHORT_LINK_BASE_URL}/studio-speaker-feedback#eid={{eventId}}&stream={{liveStreamId}}`,
    studio_permissions: `${SHORT_LINK_BASE_URL}/studio-permissions`,
    studio_screenshare: `${SHORT_LINK_BASE_URL}/how-to-screenshare-mac`,
    webhooks: `${SHORT_LINK_BASE_URL}/webhooks`,
    whats_new: `${SHORT_LINK_BASE_URL}/whats-new`,

    captions_wordly: `${KB_ARTICLE_BASE_URL}/16068314484755-Closed-captions-and-translation-using-Wordly`,
    email_type: `${KB_ARTICLE_BASE_URL}/48468261325843--Promotional-or-Transactional-email-classification`,
    event_status: `${KB_ARTICLE_BASE_URL}/5289615998355-Managing-a-workspace-s-production-status-Test-Preproduction-Production`,
    firewall_network_requirements: `${KB_ARTICLE_BASE_URL}/360051642033`,
    firewall_settings: `${KB_ARTICLE_BASE_URL}/360051642033-SpotMe-platform-corporate-firewall-network-requirements`,
    fp_type_limits: `${KB_ARTICLE_BASE_URL}/4408591514131`,
    hive_streaming: `${KB_ARTICLE_BASE_URL}/29749606817555-SpotMe-partners-with-Hive-Streaming`,
    hybrid_events: `${KB_ARTICLE_BASE_URL}/10096307255187-Hybrid-events-participants-attending-virtually-and-in-person`,
    live_stream_troubleshooting: `${KB_ARTICLE_BASE_URL}/360047591593-Troubleshooting-for-live-stream-production`,
    manual_user_approval: `${KB_ARTICLE_BASE_URL}/38707188381971-How-can-attendee-s-retrieve-access-an-existing-registration-for-an-event#h_01JVCPNPDESBZP53Q547NKBHH8`,
    meeting_ics_slots: `${KB_ARTICLE_BASE_URL}/51198523858963-Customizing-the-information-included-in-meeting-slots`,
    metadata_cc_field: `${KB_ARTICLE_BASE_URL}/40463108037139-Allowing-your-attendees-to-provide-a-secondary-contact-email-associated-with-their-user-profile`,
    metadata_editor: `${KB_ARTICLE_BASE_URL}/34643855803795-Using-the-Metadata-manager-updated-user-interface`,
    requirements: `${KB_ARTICLE_BASE_URL}/4413459400723-SpotMe-platform-user-technical-requirements#h_01FT8RRDNCD9EB7BKXNR2MGS4W`,
    rtmps_streaming_section: `${KB_SECTION_BASE_URL}/360007968334`,
    signal_wss_blocked: `${KB_ARTICLE_BASE_URL}/360051642033-Domain-allow-list-and-split-tunneling-on-corporate-networks`,
    speaker_preparation: `${KB_ARTICLE_BASE_URL}/360047006233-Preparing-your-speakers-for-a-virtual-meeting`,
    // API doc links
    api_guide: `${KB_SECTION_BASE_URL}/30040214476435-Build-your-custom-integration`,
    usage_recommendations: `${KB_ARTICLE_BASE_URL}/35763840837395-How-to-use-the-host-or-speaker-blurred-background-and-noise-removal-in-Studio`,
    registration_page_utm_tracking: `${KB_ARTICLE_BASE_URL}/9003222618643-How-to-track-where-users-are-coming-from-when-registering`,

    // video calls
    recording_more_info: `${KB_ARTICLE_BASE_URL}/360050008773-Schedule-video-breakouts#h_01K5TZ71KG9PSXFJCPWV6597T9`,

    // transcription glossaries
    transcripts_glossary_more_info: {
        boost: `${KB_ARTICLE_BASE_URL}/50199126073235-How-to-use-custom-glossaries-of-terms-for-generating-transcripts#h_01KP5C63DX1PRGFPAVM2Z12Q3Z`,
        block: `${KB_ARTICLE_BASE_URL}/50199126073235-How-to-use-custom-glossaries-of-terms-for-generating-transcripts#h_01KP5C6NB471BD674FPPTS45BW`,
        replace: `${KB_ARTICLE_BASE_URL}/50199126073235-How-to-use-custom-glossaries-of-terms-for-generating-transcripts#h_01KP5C71AMC0F73PRGWW14GN7Y`
    }
};

/**
 * Returns a link URL for given name
 *
 * @param {string} name
 * @param {Object} replacements
 * @returns {string} link URL
 */
export function getLinkUrl(name, replacements = {}) {
    return interpolateUrl(get(LINKS, name), replacements);
}
